import React from 'react';
import styled from 'styled-components';
import { useDispatch } from 'react-redux';

import {
  ELEMENT_ROOT,
  ReturnRoot,
  InsertConversationLog
} from '../store/chatmessage/actions';

import { useChatData } from './util/useChatData';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faUndo } from "@fortawesome/free-solid-svg-icons";

const EndSelectBtn = styled.div<{ color: string }>`
	width: 50px;
	padding: 5px;
	font-size: 13px;
	margin: 10px 0;
	cursor: pointer;
	text-align: center;
	color: #fff;
	background: ${(props) => props.color};
	border: 1px solid ${(props) => props.color};
	border-radius: 5px;
	transition: 0.3s ease-out;

	&:hover {
		background transparent;
		color: ${(props) => props.color};
	}
`;

const SelectBtn = styled.div<{ color: string }>`
	width: 90%;
	padding: 5px;
	font-size: 13px;
	margin: 10px 0;
	cursor: pointer;
	text-align: left;
	color: #fff;
	background: ${(props) => props.color};
	border: 1px solid ${(props) => props.color};
	border-radius: 5px;
	transition: 0.3s ease-out;

	&:hover {
		background transparent;
		color: ${(props) => props.color};
	}
`;

interface IProps {
  color: string;
  isEnd: boolean;
}

const ReturnBtn: React.FC<IProps> = ({ color, isEnd }) => {
  const dispatch = useDispatch();
  const { rootNode } = useChatData();
  const InsertLogAndReturnRoot = () => {
    dispatch(InsertConversationLog(ELEMENT_ROOT));
    dispatch(ReturnRoot(rootNode));
  };
  return (
    <React.Fragment>
      {isEnd === false ? (
        <SelectBtn color={color} onClick={() => InsertLogAndReturnRoot()}>
          <FontAwesomeIcon icon={faUndo} size="1x" /> 最初の質問に戻る
        </SelectBtn>
      ) : (
        <EndSelectBtn color={color} onClick={() => InsertLogAndReturnRoot()}>
          戻る
        </EndSelectBtn>
      )}
    </React.Fragment>
  );
};

export default ReturnBtn;
